import { BorrowerOnboardingDetails, DATE_FORMAT, DocumentType, formatDate } from '@nemuru-eng/js-api-client';

import {
  NIE_EU_CARD_ID,
  NIE_EU_EXPIRATION_DATE_CARD,
} from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/constants/nieEuData.constants';
import { isNieEuDocumentType } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/utils/nieDocumentTypes.utils';

type NieDataRequestPayload = {
  nationalityPeriod: NonNullable<BorrowerOnboardingDetails['nieData']>['nationalityPeriod'];
  cardId: NonNullable<BorrowerOnboardingDetails['nieData']>['cardId'];
  expirationDateCard: string;
  socialSecurityDate: string;
  numberOfWork: number;
};

const formatNieDataDate = (value: Date | string): string => {
  if (typeof value === 'string') {
    return value;
  }

  return formatDate(value, DATE_FORMAT.YYYY_MM_DD);
};

export const mapNieDataToApiRequest = (
  documentType: DocumentType,
  nieData: NonNullable<BorrowerOnboardingDetails['nieData']>,
): NieDataRequestPayload => {
  if (isNieEuDocumentType(documentType)) {
    return {
      nationalityPeriod: nieData.nationalityPeriod,
      cardId: NIE_EU_CARD_ID,
      expirationDateCard: NIE_EU_EXPIRATION_DATE_CARD,
      socialSecurityDate: formatNieDataDate(nieData.socialSecurityDate),
      numberOfWork: nieData.numberOfWork,
    };
  }

  return {
    nationalityPeriod: nieData.nationalityPeriod,
    cardId: nieData.cardId,
    expirationDateCard: formatNieDataDate(nieData.expirationDateCard),
    socialSecurityDate: formatNieDataDate(nieData.socialSecurityDate),
    numberOfWork: nieData.numberOfWork,
  };
};
